import fateSchema from './fate.schema';
import * as fateGetters from './fate.getters';
import * as fateRuleset from './fate.ruleset';
import * as fateModifiers from './fate.modifiers';
import * as fateStatus from './fate.status';
import * as fateUtils from './fate.utils';
import { Pet } from '../pet';
import { ReplicantModuleState } from '../../utils';
import { Immutable } from '@play-co/replicant';
import { PetStats } from '../pet/stats';
import { VisitRecord } from '../../visit/record';

export type Fate = typeof Fate;
// eslint-disable-next-line no-redeclare
export namespace Fate {
  export const $DEPENDENCIES = { Pet, PetStats, VisitRecord };

  export const ruleset = fateRuleset;
  export const schema = fateSchema;

  export const api = {
    ...fateGetters,
    ...fateStatus,
    ...fateModifiers,
    ...fateUtils,
  };

  export type MutableState = ReplicantModuleState<Fate>;
  export type State = Immutable<MutableState>;
}
